class MobileHeader extends HTMLDivElement {
  connectedCallback () {
    if (window.innerWidth < 1200) {
      this.observeHeader()
    }
  }

  observeHeader () {
    const transparentOverMeSections = document.querySelectorAll('[data-transparent-over-me]')
    const announcementBarHeight = document.querySelector('.hd-AnnouncementBar')?.offsetHeight || 0
    const headerHeight = this.offsetHeight + announcementBarHeight

    this.hasTransparentSectionFirst = this.checkIfFirstSectionIsTransparent()
    if (this.hasTransparentSectionFirst) {
      document.body.style.setProperty('--header-height', `${announcementBarHeight}px`)
    } else {
      document.body.style.setProperty('--header-height', `${headerHeight}px`)
    }

    const observer = new IntersectionObserver(
      entries => {
        let anyIntersecting = false

        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const top = entry.boundingClientRect.top - announcementBarHeight

            if (top <= 0) {
              anyIntersecting = true
            }
          }
        })

        if (anyIntersecting) {
          this.setTransparent()
        } else {
          this.removeTransparent()
        }
      },
      {
        root: null,
        rootMargin: `${headerHeight}px 0px -${headerHeight}px 0px`,
        threshold: [0, 0.1, 1.0], // Multiple thresholds for better detection
      },
    )

    transparentOverMeSections.forEach(section => {
      observer.observe(section)
    })
  }

  setTransparent () {
    if (!this.classList.contains('hd-MobileHeader-transparent')) {
      this.classList.add('hd-MobileHeader-transparent')
    }
  }

  removeTransparent () {
    if (this.classList.contains('hd-MobileHeader-transparent')) {
      this.classList.remove('hd-MobileHeader-transparent')
    }
  }

  checkIfFirstSectionIsTransparent () {
    const firstShopifySection = document.querySelector('#MainContent .shopify-section:first-child')
    const firstTransparentElement = firstShopifySection?.querySelector('[data-transparent-over-me]')

    return !!firstTransparentElement
  }
}

customElements.define('mobile-header', MobileHeader, { extends: 'div' })
